export const MOMENT_STRATEGY_VALUES = [
    'mixed',
    'emotional',
    'quotable',
    'hooks',
    'action',
    'custom',
];
export const MOMENT_TYPE_VALUES = [
    'emotional',
    'quotable',
    'hook',
    'action',
    'other',
];
export const MOMENT_TRANSCRIPTION_STATUS_VALUES = ['none', 'pending', 'transcribed', 'error'];
//# sourceMappingURL=moment.js.map